import React from 'react'

export default function InputErrorDisplayer({ message, className = "" }) {
    if (!message) return null;
    return (
        <div className={`text-red-500 text-xs mt-2 ${className}`}>{message}</div>
    )
}
